export default "__VITE_ASSET__YyjjPCim__"